const apiUrl = "https://api.max.delivery/api/";
// const apiUrl = "http://localhost:8000/api/";

export default apiUrl;
